import { FC } from 'react';
import s from './desktopHeader.module.scss';
import { SocialManagerView } from '@specs/views';
import cn from 'classnames';
import { Actions } from '@components/Pages/ProfilePages/Actions/Actions';
interface Props {
  shortid: SocialManagerView.publicProfile['shortid'];
  isMyProfile: boolean;
  id: number;
}
export const DesktopHeader: FC<Props> = ({
  shortid,
  isMyProfile
}) => {
  return <div className={cn(s.desktopHeader, '_tablet')} data-sentry-component="DesktopHeader" data-sentry-source-file="DesktopHeader.tsx">
            <h1 className={cn('_title', '_ellipsis')}>
                {shortid}
            </h1>
            <Actions shortid={shortid} isMyProfile={isMyProfile} data-sentry-element="Actions" data-sentry-source-file="DesktopHeader.tsx" />
        </div>;
};